var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 59"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_58561_10526",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 29.4286C9 29.1919 9.19188 29 9.42857 29H14.5714C14.8081 29 15 29.1919 15 29.4286C15 30.8487 13.8487 32 12.4286 32H11.5714C10.1513 32 9 30.8487 9 29.4286Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9 29.4286C9 29.1919 9.19188 29 9.42857 29H14.5714C14.8081 29 15 29.1919 15 29.4286C15 30.8487 13.8487 32 12.4286 32H11.5714C10.1513 32 9 30.8487 9 29.4286Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_58561_10526)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 26C21.5523 26 22 25.5523 22 25V12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12L2 25C2 25.5523 2.44772 26 3 26H21ZM12 0C5.37258 0 0 5.37258 0 12V26C0 27.1046 0.89543 28 2 28H22C23.1046 28 24 27.1046 24 26V12C24 5.37258 18.6274 0 12 0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7);
export default __webpack_public_path__ + "static/media/Group 7.79a1969f48508a7459f9ff0edfd3e857.svg";
export { ForwardRef as ReactComponent };